import { useOnSessionStorageChange } from '../hooks';

const storageKey = 'last-payment-provider-update';

export const setLastPaymentProviderUpdate = () =>
  sessionStorage.setItem(storageKey, new Date().toString());

const reloadPage = () => window.location.reload();

// we use a full page refresh to also update the angular app
export const useReloadPageOnPaymentProviderUpdated = () =>
  useOnSessionStorageChange(storageKey, reloadPage);
